module.exports = __webpack_public_path__ + "static/media/volar-platinum.a65b8b49.png";